export const shareTranslations = {
  SHARE_TITLE: "The shared tickets will be available in the Tranzer app",
  SHARE_SUBTITLE: "You will be redirected now"
};
